import React from 'react';
import { Section, SectionHeading, Reveal } from './ui/Section';
import { IconChatAi, IconShield, IconClock, IconDesktop, IconYen } from './illustrations/Icons';

const REASONS = [
  {
    no: '01',
    Icon: IconChatAi,
    title: '自然言語入力',
    description: '話すように入力、AIが自動理解',
    body: '専門用語や操作手順を覚える必要はありません。日本語でそのまま伝えるだけで、AIが内容を読み取り仕訳に変換します。',
  },
  {
    no: '02',
    Icon: IconShield,
    title: '高度なセキュリティ',
    description: 'クラウドより安全な環境',
    body: '会計データが社外のサーバーを経由することはありません。持ち出す経路そのものが無いため、情報漏洩のリスクを構造的に断ちます。',
  },
  {
    no: '03',
    Icon: IconClock,
    title: '時間削減',
    description: '作業時間を最大80%削減',
    body: '記帳・集計・決算書作成といった反復作業をAIが引き受けます。経理担当者は数字の確認と判断に集中できます。',
  },
];

const PILLARS = [
  {
    Icon: IconDesktop,
    title: '外部接続一切不要',
    body: 'すべてのデータはお客様のPC内で完結します。',
  },
  {
    Icon: IconShield,
    title: 'データは100%社内保存',
    body: 'クラウドへの依存ゼロ。情報漏洩リスクをゼロに。',
  },
  {
    Icon: IconYen,
    title: '月額費用を大幅削減',
    body: '高額なクラウド費用が不要なため、低価格を実現。',
  },
];

const Reasons: React.FC = () => (
  <Section id="reasons" tone="ink" className="relative overflow-hidden">
    {/* 背景の装飾 */}
    <div
      className="pointer-events-none absolute inset-0 opacity-[0.35]"
      style={{
        backgroundImage:
          'radial-gradient(circle at 15% 20%, rgba(242,107,33,0.16), transparent 42%), radial-gradient(circle at 85% 75%, rgba(47,91,133,0.5), transparent 45%)',
      }}
    />

    <div className="relative">
      <SectionHeading
        eyebrow="Why Sakumie"
        title="サクミエ会計の強み"
        lead="クラウドに依存しないという選択が、安全性とコストの両方を同時に解決します。"
        tone="light"
      />

      <div className="mt-14 grid gap-6 lg:grid-cols-3">
        {REASONS.map((r, i) => (
          <Reveal key={r.title} delay={i * 0.1}>
            <div className="h-full rounded-card border border-white/12 bg-white/[0.06] p-8 backdrop-blur-sm transition-colors duration-300 hover:border-white/25 hover:bg-white/[0.09]">
              <div className="flex items-center justify-between">
                <span className="num text-eyebrow uppercase text-brand-300">{r.no}</span>
                <r.Icon className="h-10 w-10 text-brand-300" />
              </div>
              <h3 className="mt-5 text-h3 text-white">{r.title}</h3>
              <p className="mt-1 text-small font-medium text-brand-200">{r.description}</p>
              <p className="mt-4 text-small leading-relaxed text-ink-200">{r.body}</p>
            </div>
          </Reveal>
        ))}
      </div>

      {/* 完全独立システムの説明 */}
      <Reveal delay={0.24}>
        <div className="mt-16 rounded-card border border-white/12 bg-white/[0.04] p-8 sm:p-12">
          <h3 className="text-center text-h3 text-white">AI内蔵で完全独立システム</h3>
          <div className="mx-auto mt-2 h-0.5 w-12 rounded-pill bg-brand-500" />

          <div className="mt-10 grid gap-8 sm:grid-cols-3">
            {PILLARS.map((p) => (
              <div key={p.title} className="text-center">
                <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-brand-500/15 ring-1 ring-brand-400/30">
                  <p.Icon className="h-7 w-7 text-brand-400" />
                </div>
                <p className="mt-4 font-bold text-white">{p.title}</p>
                <p className="mt-2 text-small leading-relaxed text-ink-200">{p.body}</p>
              </div>
            ))}
          </div>
        </div>
      </Reveal>
    </div>
  </Section>
);

export default Reasons;
